import { Card, Col, Row, Typography, DatePicker, Input, Checkbox, Radio, Space, Select, Button,Spin } from "antd"
import { ModalReport } from "components/otros/ModalReport"
import { ReportOrdenCompra } from "hooks/compras/ReportOrdenCompra"
import useGenerarOrden from "hooks/compras/useGenerarOrden"
import moment from "moment"

const { Title } = Typography
interface GenerarOrdenProps {
  setOpenModalGen: Function,//React.Dispatch<React.SetStateAction<boolean>>;
  setdataProductosOrden: Function,
  SumProveedorOrdenCompra:Function
}


export default function GenerarOrden({setOpenModalGen, setdataProductosOrden, SumProveedorOrdenCompra }: GenerarOrdenProps) {
  const disabledDate = (current: any) => {return current && current > moment().endOf("day")}
  const {    
    SoloNumeros,
    DiasMinimos,
    DiasMaximos,
    MinA, setMinA,
    MinB, setMinB,
    MinC, setMinC,
    MaxA, setMaxA,
    MaxB, setMaxB,
    MaxC, setMaxC,
    onchangeFecha,
    Fecha,
    onchangeFechaDevolucion,
    FechaDevolucion,
    PedirMatriz, onchangePedirMatriz,
    onChangeModoAccion, ModoAccion,
    onChangeTipoSugerido, TipoSugerido,
    onchangeBajoStock,BajoStock,
    onChangeLaboratorio, 
    onChangeProveedores, Proveedores,
    btnGenerarOrden,
    openModal, setOpenModal, onChangeDiasMinimos, 
    onChangeDiasMaximos,dataLaboratorio, DataLineaLaboratorio, onChangeLineasLab,
    dataProductos,onChangeProductos,dataBodega, onChangeBodega, Bodega,LineasLaboratorio,
    openLineas,setopenLineas,
    openLaboratorio, setopenLaboratorio, LoaderOrdCom
  }=useGenerarOrden(SumProveedorOrdenCompra)
  return (
    <>
    {LoaderOrdCom&&(<><Row
          style={{
            justifyContent: "center",
            textAlign: "center",
            display: "flex",
            background: "white",
            padding: "40px",
            height: "100%",
            paddingTop: "80px",
          }}
        >
          <Spin style={{ fontSize: "20px" }} />
        </Row>
        <Row justify={"center"} align={"middle"}           style={{
            justifyContent: "center",
            textAlign: "center",
            display: "flex",
            background: "white",
            padding: "40px",
            height: "100%",
            //paddingTop: "40px",
          }}><Title level={5}>Generando Información...</Title></Row>
      </>  
      )

    }
      {!LoaderOrdCom&&<Row>
        <Card style={{ width: "100%" }} bordered={false}>
          <Row style={{ width: "100%", background: "white", paddingRight: "20px",marginBottom:'8px' }} justify={"end"}>
            <Button type="primary" onClick={()=>btnGenerarOrden(setOpenModalGen, setdataProductosOrden)} size="small">Generar Orden</Button>
          </Row>
          <Row>
            <Col sm={24} md={12} xs={24}>
              <Row>
                <Col sm={12} md={6} xs={10}>
                  <Title level={5} style={{fontSize:'12px'}}>Fecha</Title>
                </Col>
                <Col sm={12} md={18} xs={14}>
                  <DatePicker style={{ width: "95%", fontSize:'12px' }} size="small" onChange={onchangeFecha} value={Fecha} disabledDate={disabledDate}/>
                </Col>
              </Row>
              <Row>
                <Col xs={10} sm={12} md={6}>
                  <Title level={5} style={{fontSize:'12px'}} >Pedir por matriz</Title>
                </Col>
                <Col xs={14} sm={12} md={18}>
                  <Checkbox  style={{ width: "95%", fontSize:'12px' }} onChange={onchangePedirMatriz} checked={PedirMatriz} disabled></Checkbox>
                </Col>
              </Row>
              {!PedirMatriz&&<Row>
                <Col sm={8} md={6} xs={10}>
                  <Title level={5} style={{fontSize:'12px'}}>Sucursal</Title>
                </Col>
                <Col sm={16} md={18} xs={14}>
                  <Select size="small" style={{ width: "95%", fontSize:'12px' }} options={dataBodega} onChange={onChangeBodega} value={Bodega} placeholder="Seleccione una Sucursal"/>
                </Col>
              </Row>}
              <Row>
                <Col xs={10} sm={12} md={6}>
                  <Title level={5} style={{fontSize:'12px'}}>Modo de Acción</Title>
                </Col>
                <Col xs={14} sm={14} md={18}>
                  <Radio.Group onChange={onChangeModoAccion} value={ModoAccion} style={{ width: "95%", fontSize:'12px' }} size="small">
                    <Space direction="horizontal" size={"small"}>
                      <Radio value={1} style={{fontSize:'12px'}}>Modo Actual</Radio>
                      <Radio value={2} style={{fontSize:'12px'}}>Con Flow</Radio>
                    </Space>
                  </Radio.Group>
                </Col>
              </Row>
              <Row style={{marginBottom:'5px'}}>
                <Col sm={12} md={6} xs={10}>
                  <Title level={5} style={{fontSize:'12px'}}>Fecha Devolución</Title>
                </Col>
                <Col sm={12} md={18} xs={14}>
                  <DatePicker style={{ width: "95%", fontSize:'12px' }} size="small" onChange={onchangeFechaDevolucion} value={FechaDevolucion} disabledDate={disabledDate}/>
                </Col>
              </Row>
              <Card style={{ width: "96.5%" }}>
                <Row>
                  <Col sm={8} xs={8} md={4} style={{ textAlign: "center" }}>
                    <Title level={5} style={{ fontSize: "12px" }}>
                      Categoría
                    </Title>
                  </Col>
                  <Col sm={8} xs={8} md={10} style={{ textAlign: "center" }}>
                    <Title level={5} style={{ fontSize: "12px" }}>
                      Días Mínimos
                    </Title>
                  </Col>
                  <Col sm={8} xs={8} md={10} style={{ textAlign: "center" }}>
                    <Title style={{ fontSize: "12px" }}>Días Máximos</Title>
                  </Col>
                </Row>
                <Row>
                  <Col sm={8} xs={8} md={4} style={{ textAlign: "center" }}>
                    <Title style={{ fontSize: "12px" }}>A</Title>
                  </Col>
                  <Col sm={8} xs={8} md={10}>
                    <Input size="small" style={{textAlign:'right'}} onChange={(e)=>SoloNumeros(e, setMinA)} value={MinA}/>
                  </Col>
                  <Col sm={8} xs={8} md={10}>
                    <Input size="small" style={{textAlign:'right'}} onChange={(e)=>SoloNumeros(e, setMaxA)} value={MaxA}/>
                  </Col>
                </Row>
                <Row>
                  <Col sm={8} xs={8} md={4} style={{ textAlign: "center" }}>
                    <Title style={{ fontSize: "12px" }}>B</Title>
                  </Col>
                  <Col sm={8} xs={8} md={10}>
                    <Input size="small" style={{textAlign:'right'}} onChange={(e)=>SoloNumeros(e, setMinB)} value={MinB}/>
                  </Col>
                  <Col sm={8} xs={8} md={10}>
                    <Input size="small"  style={{textAlign:'right'}} onChange={(e)=>SoloNumeros(e, setMaxB)} value={MaxB}/>
                  </Col>
                </Row>
                <Row>
                  <Col sm={8} xs={8} md={4} style={{ textAlign: "center" }}>
                    <Title style={{ fontSize: "12px" }}>C</Title>
                  </Col>
                  <Col sm={8} xs={8} md={10}>
                    <Input size="small" style={{textAlign:'right'}} onChange={(e)=>SoloNumeros(e, setMinC)} value={MinC}/>
                  </Col>
                  <Col sm={8} xs={8} md={10}>
                    <Input size="small" style={{textAlign:'right'}} onChange={(e)=>SoloNumeros(e, setMaxC)} value={MaxC}/>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col sm={24} md={12} xs={24}>
              <Row>
                <Col sm={12} md={6} xs={10}>
                  <Title level={5} style={{fontSize:'12px'}}>Días Mínimos</Title>
                </Col>
                <Col sm={12} md={18} xs={14}>
                  <Input size="small" style={{ width: "95%", textAlign:'right', fontSize:'12px' }} onChange={(e)=>onChangeDiasMinimos(e)} value={DiasMinimos}/>
                </Col>
              </Row>
              <Row>
                <Col sm={8} md={6} xs={10}>
                  <Title level={5} style={{fontSize:'12px'}}>Días Máximos</Title>
                </Col>
                <Col sm={16} md={18} xs={14}>
                  <Input size="small" style={{ width: "95%", textAlign:'right', fontSize:'12px' }}  onChange={(e)=>onChangeDiasMaximos(e)} value={DiasMaximos}/>
                </Col>
              </Row>
              <Row style={{paddingBottom:'2px'}}>
                <Col sm={8} md={6} xs={10}>
                  <Title level={5} style={{fontSize:'12px'}}>Tipo Sugerido</Title>
                </Col>
                <Col sm={16} md={18} xs={14}>
                  <Select style={{ width: "95%", fontSize:'12px' }} dropdownStyle={{fontSize:'12px'}} size="small" onChange={onChangeTipoSugerido} value={'laboratorio'} disabled /* value={TipoSugerido} */ options={[{label:'Laboratorio', value:'laboratorio'}, { label: "Producto", value:'producto'}]}/>
                </Col>
              </Row>
{TipoSugerido!=='producto'&&<> <Row>
                <Col sm={12} md={6} xs={10}>
                  {" "}
                  <Title level={5} style={{fontSize:'12px'}}>Laboratorio</Title>
                </Col>
                <Col sm={12} md={18} xs={14}>
                  <Select
                    showSearch
                    mode="multiple"
                    size={"small"}
                    placeholder="Seleccione un Laboratorio"
                    dropdownStyle={{fontSize:'10px'}}
                    open={openLaboratorio}
                    onDropdownVisibleChange={(visible) => setopenLaboratorio(visible)}
                    onSelect={() => setopenLaboratorio(false)} 
                    //value={}
                    onChange={onChangeLaboratorio}
                    style={{ width: "95%", marginBottom:'2px', fontSize:'12px' }}
                    options={dataLaboratorio}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Col>
              </Row>
              <Row style={{paddingBottom:'2px'}}>
                <Col sm={10} xs={10} md={6}>
                  <Title level={5} style={{fontSize:'12px'}}>Líneas de Laboratorio</Title>
                </Col>
                <Col sm={10} xs={14} md={18}>
                  <Select mode="multiple" size="small" style={{ width: "95%", fontSize:'12px' }}   value={LineasLaboratorio} dropdownStyle={{fontSize:'10ppx', margin: '0', padding:'0' }} placeholder="Seleccione una Línea de Laboratorio" onChange={onChangeLineasLab} options={DataLineaLaboratorio}
                                      filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                      }
                                      open={openLineas}
                    onDropdownVisibleChange={(visible) => setopenLineas(visible)}
                    onSelect={() => setopenLineas(false)} 
                  />
                </Col>
              </Row></>}
             {TipoSugerido==='producto'&& <Row>
                <Col sm={10} xs={10} md={6}>
                  <Title level={5} style={{fontSize:'12px'}}>Por Producto</Title>
                </Col>
                <Col sm={10} xs={14} md={18} style={{height:'100%'}}>
                  <Select style={{ width: "95%" , height:'100%', fontSize:'12px'}} size="small"options={dataProductos} onChange={onChangeProductos} /* value={productos} */ placeholder='Selecciona un Producto' />
                </Col>
              </Row>}
              <Row>
                <Col sm={10} xs={10} md={6}>
                  <Title level={5} style={{fontSize:'12px'}}>Proveedores devoluciones rebate y otros</Title>
                </Col>
                <Col sm={10} xs={14} md={18} style={{height:'100%'}}>
                  <Select style={{ width: "95%" , height:'100%', fontSize:'12px'}} dropdownStyle={{fontSize:'12px'} }size="small" onChange={onChangeProveedores} value={Proveedores} placeholder='Selecciona una Linea de Laboratorio' />
                </Col>
              </Row>
              <Row>
                <Col sm={10} xs={10} md={6}>
                  <Title level={5} style={{fontSize:'12px'}}>Bajo de Stock</Title>
                </Col>
                <Col sm={10} xs={14} md={18}>
                  <Checkbox onChange={onchangeBajoStock} checked={BajoStock}></Checkbox>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Row>}

            <ModalReport openModal={openModal}
            setOpenModal={setOpenModal}
            titleModal="Orden de Compra #"
            pdfName={`Orden de Compra`}
            >
              <ReportOrdenCompra/>
            </ModalReport>
    </>
  )
}
